import { combineReducers } from 'redux';
import { reducer as teaser } from './teaser';
import { reducer as tag } from './tag';
import { reducer as filter } from './filter';
import { reducer as system } from './system';
import { reducer as person } from './person';

export const reducers = combineReducers({
	tag,
	teaser,
	filter,
	system,
	person
});


// WEBPACK FOOTER //
// ./src/reducers/index.js